/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import { cssMap, cx, jsx } from '@atlaskit/css';
import SmartLinkListIcon from '@atlaskit/icon/core/smart-link-list';
import { Anchor } from '@atlaskit/primitives/compiled/anchor';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';
import { SearchIcon } from './search-icon';

const styles = cssMap({
	root: {
		paddingTop: token('space.050'),
		paddingRight: token('space.050'),
		paddingBottom: token('space.050'),
		paddingLeft: token('space.050'),
		backgroundColor: token('color.background.input'),
		borderStyle: 'solid',
		borderWidth: token('border.width'),
		borderColor: token('color.border'),
		borderRadius: token('radius.small'),
	},
	tabOptionStyles: {
		backgroundColor: token('color.background.input'),
		paddingLeft: token('space.075'),
		paddingRight: token('space.100'),
		borderRadius: token('radius.small'),
		height: '22px',
	},
	tabOptionLinkStyles: {
		textDecoration: 'none',
		'&:hover': {
			textDecoration: 'none',
		},
	},
	tabOptionSelectedStyles: {
		backgroundColor: token('color.background.selected'),
	},
	searchIconWrapperStyles: {
		width: '16px',
		height: '16px',
	},
});

type AIModeTabsProps = {
	query: string;
	tenantDomain?: string;
};

export const AIModeTabs: ({ query, tenantDomain }: AIModeTabsProps) => JSX.Element = ({
	query,
	tenantDomain,
}: AIModeTabsProps) => {
	const intl = useIntl();

	return (
		<Box xcss={styles.root}>
			<Inline space="space.0">
				<Pressable xcss={cx(styles.tabOptionStyles, styles.tabOptionSelectedStyles)}>
					<Inline space="space.050" alignBlock="center">
						<SmartLinkListIcon color={token('color.icon.selected')} label="" />
						<Text color="color.text.selected" weight="medium">
							{intl.formatMessage(messages.results)}
						</Text>
					</Inline>
				</Pressable>
				<Anchor
					xcss={cx(styles.tabOptionStyles, styles.tabOptionLinkStyles)}
					href={`${tenantDomain}/wiki/ai-search/?aiSearchQuery=${query}`}
				>
					<Inline space="space.050" alignBlock="center">
						<Box xcss={styles.searchIconWrapperStyles}>
							<SearchIcon />
						</Box>
						<Text color="color.text.subtle" weight="medium">
							{intl.formatMessage(messages.aiMode)}
						</Text>
					</Inline>
				</Anchor>
			</Inline>
		</Box>
	);
};
